export default __webpack_public_path__ + "static/media/service-road.77252c08.svg";